export default `---
slug: sweden
country: Sweden
countryCode: SWE
continent: Europe
year: 2020
title: "Sweden — The Erasmus Chapter"
description: "Six months in Stockholm for the Erasmus at KTH. Midsummer, snus, Viking food, and the best academic semester of my life."
thumbnail: /images/travels/SWE/sweden_thumb.jpg
relatedLinks: []
---
![sweden](/images/travels/SWE/sweden_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Sweden and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
